import createImageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import SanityHeadSeo from "../sanity/Components/SanityHeadSeo/SanityHeadSeo";
import BesoinAideCard from "../SanityComponents/CalculezVotreBudgetComponents/BesoinAideComponent/BesoinAideCard/BesoinAideCard";
import BesoinAideQuest from "../SanityComponents/CalculezVotreBudgetComponents/BesoinAideComponent/BesoinAideQuest/BesoinAideQuest";
import BudgetHeader from "../SanityComponents/CalculezVotreBudgetComponents/BudgetHeader/BudgetHeader";
import CalculezBudget from "../SanityComponents/CalculezVotreMensualite/CalculeMensualiteActions/CalculeBudgetActions";
import Footer from "../SanityComponents/Footer/Footer";
import Question from "../SanityComponents/Question/Question";
import style from "./style.module.css";
import FAQ from "SanityComponents/FAQ/FAQ";
import WhatssapComponent from "SanityComponents/WhatssapComponent";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});

function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

function CalculezVotreBudget(props: { data: any | null }) {
  const { t, lang } = useTranslation("common");

  const { data } = props;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        paddingTop: "100px",
        width: "100%",
      }}
    >
      {data?.content.map((item, key) => {
        if (item._type == "lpheader") {
          return (
            <>
              <BudgetHeader
                title={item.titre ? item.titre[lang] : ""}
                subtitle={item.soustitre ? item.soustitre[lang] : ""}
              />
              <CalculezBudget />
            </>
          );
        } else if (item._type == "WhatssapComponent") {
          return (
            <WhatssapComponent
              number={item?.numberPhone ? item.numberPhone : null}
              message={item?.message ? item.message[lang] : null}
            />
          )
        } else if (item._type == "SanityHeadSeo") {
          return (
            <SanityHeadSeo
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              ogTitle={item.titre ? item.titre[lang] : ""}
              description={item.description ? item.description[lang] : ""}
              ogDescription={item.description ? item.description[lang] : ""}
              canonicalUrl={item.canonicalUrl}
              ogTwitterImage={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              ogType={item.ogType}
              ogImageUrl={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              structuredData={null}
            >
              <></>
            </SanityHeadSeo>
          );
        } else {
          return (
            <>
              {item._type == "SubHeader" && (
                <BesoinAideQuest
                  title={item.titre ? item.titre[lang] : ""}
                  subTitle={item.subTitle[lang]}
                />
              )}
              {item.CalculCard?.length > 0 && (
                <div className={style.BesoinCardsContainer}>
                  {item.CalculCard.map((element, ind) => {
                    return (
                      <>
                        <BesoinAideCard
                          title={element.titre ? element.titre[lang] : ""}
                          description={
                            element.description ? element.description[lang] : ""
                          }
                        />
                      </>
                    );
                  })}
                </div>
              )}

              {item._type == "QuestionImmobilier" && (
                <div className={style.QuestionImmobilier}>
                  <Question
                    title={item.titre ? item.titre[lang] : ""}
                    buttonText={item.button_text ? item.button_text[lang] : ""}
                    image={urlFor(item.mainImage)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    button_link={item.button_link}
                  />
                </div>
              )}
              {item._type == "Faq" && (
                <>
                  <FAQ data={item} lang={lang} />;
                </>
              )}
              {item._type == "SanityFooter" && (
                <div className={style.footer}>
                  <div className={style.footerDesk}>
                    <Footer
                      propos={item.propos[lang]}
                      proposText={item.text ? item.text[lang] : ""}
                      donnee={item.donnees[lang]}
                      donneeText={item.textdonnee[lang]}
                      technologie={item.technologie[lang]}
                      technologieText={item.texttechnologies[lang]}
                      logo={urlFor(item.agenz_logo)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()}
                      facebook={urlFor(item.facebook_logo)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()}
                      instagram_logo={urlFor(item.instagram_logo)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()}
                      linked_in={urlFor(item.linkedin_logo)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()}
                      socialMediaText={item.socialMediatext}
                      copyRightText={item.permission_text}
                    />
                  </div>
                </div>
              )}
            </>
          );
        }
      })}
    </div>
  );
}

export default CalculezVotreBudget;
